import { setTerms } from './helpers';

export const setHeatingSourceTypes = setTerms('heating_source_type');
